import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  components: {
    InstitutionInactive,
  },

  created() {
    if (this.$route.query.id) {
      this.listIds = this.$route.query.id.split(',')

      this.userType = JSON.parse(localStorage.getItem('institution')).userType
      const institution = JSON.parse(localStorage.getItem('institution'))
      this.institutionId = institution.id
      this.institutionInactive = institution.status == 1
      this.workshopType = institution.workshopType
      window.scrollTo(0, 0)
      this.getManufacturers()
      this.getUndiades()
      this.getStandardEquipment()
      this.getDepartments()
      this.getCostCenters()
      this.getSuppliers()
      this.getEquipmentsByIds()
    }
  },

  data: () => ({
    listIds: null,
    subDepartmentId: null,
    errorMessage: '',
    anvisa: null,
    loading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    departmentLoading: false,
    firstValid: true,
    secondCheckboxValid: true,
    thirdValid: true,
    secondValid: true,
    thirdValid: true,
    error: false,
    confirmDialog: false,
    fieldUnidade: false,
    fieldSituation: false,
    fieldAnvisa: false,
    fieldMarketValue: false,
    fieldvalue: false,
    fieldBuyDate: false,
    fieldtecnologyFactor: false,
    fieldConservationState: false,
    fieldSubDepartment: false,
    fieldResidualFactor: false,
    fieldEndLife: false,
    fieldDepartment: false,
    fieldStandardEquipment: false,
    fieldModel: false,
    fieldManufacturer: false,

    editUnidade: false,
    editSituation: false,
    editAnvisa: false,
    editMarketValue: false,
    editvalue: false,
    editBuyDate: false,
    edittecnologyFactor: false,
    editConservationState: false,
    editSubDepartment: false,
    editResidualFactor: false,
    editEndLife: false,
    editDepartment: false,
    editStandardEquipment: false,
    editModel: false,
    editManufacturer: false,
    candlePowerUnits: ['W', 'VA', 'KVA', 'BTU', 'CV'],
    candlePowerUnit: 'W',
    voltages: [
      { id: 0, name: '110V' },
      { id: 1, name: '220V' },
      { id: 2, name: '110V / 220V - Bivolt' },
      { id: 3, name: '220V Trifásico' },
      { id: 4, name: '380V Trifásico' },
      { id: 5, name: '440V' },
      { id: 6, name: '480V' },
      { id: 7, name: '13,8KV' },
    ],
    fieldSituation: false,
    fieldSupplier: false,
    institutionInactive: false,
    endLifeFactor: null,
    purchasePrice: null,
    technologyFactor: null,
    marketValue: null,
    model: null,
    step: 1,
    workshopType: null,
    institutionId: null,
    residualFactor: null,
    conservationState: null,
    unidadeId: null,
    unidades: [],
    standardEquipmentId: null,
    standardEquipments: [],
    departmentId: null,
    departments: [],
    costCenterId: null,
    reason: null,
    costCenters: [],
    supplierId: null,
    suppliers: [],
    equipment: [],
    userType: null,
    manufacturer: null,
    menuPurchaseDate: false,
    purchaseDate: null,
    voltage: null,
    candlePower: null,
    situation: null,
    indexAbc: null,
    purchaseDateModel: null,
    lifeExpectancy: null,
    criticality: null,
    conservationStates: [
      { text: 'Bom', value: 0 },
      { text: 'Ruim', value: 1 },
      { text: 'Péssimo', value: 2 },
    ],
    endLifeFactors: [
      { text: 'Atual', value: null },
      { text: 'End of Life', value: 0 },
      { text: 'End of Service', value: 1 },
    ],
    technologyFactors: [
      { text: 'Atual', value: 0 },
      { text: 'Defasagem Mínima', value: 1 },
      { text: 'Defasado', value: 2 },
    ],
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
      'Convênio',
    ],
    unidadeRules: [(v) => !!v || 'Unidade requerida'],
    quantityRules: [
      (v) => !!v || 'Quantidade requerida',
      (v) => (v && v != 0) || 'Quantidade tem que ser maior que zero',
    ],
    standardEquipmentRules: [(v) => !!v || 'Equipamento padrão requerido'],
    departmentRules: [(v) => !!v || 'Setor requerido'],
    nameRules: [
      (v) => !!v || 'Equipamento requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Equipamento deve ter no máximo 128 caracteres',
    ],
    manufacturerRules: [
      (v) =>
        !v || v.length <= 128 || 'Fabricante deve ter no máximo 128 caracteres',
    ],
    modelRules: [
      (v) => !v || v.length <= 64 || 'Modelo deve ter no máximo 64 caracteres',
    ],
    candlePowerRules: [
      (v) =>
        !v || v.length <= 10 || 'Potência deve ter no máximo 10 caracteres',
    ],
    serialNumberRules: [
      (v) =>
        !v || v.length <= 20 || 'Nº de série deve ter no máximo 20 caracteres',
    ],
    propertyCodeRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Cód. patrimônio deve ter no máximo 20 caracteres',
    ],
    numberAnvisaRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Número Anvisa deve ter no máximo 20 caracteres',
    ],
    apiService: new ApiService(),
    generalService: new GeneralService(),
    manufacturers: [],
    manufLoading: false,
    reasonModal: false,
  }),

  computed: {
    subDepartments() {
      const department = this.departments.find((x) => x.id == this.departmentId)
      return department ? department.subDepartments : []
    },

    buttonText() {
      switch (this.step) {
        case 4:
          return 'Editar'
        default:
          return 'Próximo'
      }
    },
  },

  methods: {
    save(date) {
      this.purchaseDateModel = this.formatInputDate(this.purchaseDate)

      this.$refs.menuPurchaseDate.save(date)
    },
    save2(index) {
      this.equipment[index].formatPurchaseDate = this.formatInputDate(
        this.equipment[index].purchaseDate
      )
    },
    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
    async getEquipmentsByIds() {
      const filter = {
        InstitutionId: this.institutionId,
        EquipmentIds: this.listIds,
      }
      await this.apiService
        .post(`equipment/getEquipmentsById`, filter)
        .then((response) => {
          this.equipment = response.content

          this.equipment.map((x) => {
            x.formatPurchaseDate = this.formatInputDate(x.purchaseDate)
          })
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },
    getManufacturers() {
      this.manufLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufLoading = false
        })
        .catch(() => {
          this.manufLoading = false
        })
    },

    close() {
      this.$router.push('/equipment')
    },
    formatInitialDate(dateInitial) {
      if (!dateInitial) return null
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    next() {
      switch (this.step) {
        case 1:
          if (this.$refs.firstForm.validate()) {
            this.step++
          }
          break
        case 2:
          if (this.$refs.secondCheckboxForm.validate()) {
            if (this.fieldDepartment && !this.fieldUnidade) {
              const unidadeRef = this.equipment[0].unidadeId

              const EqualsUnidade = this.equipment.reduce((result, x) => {
                if (!result) {
                  return false
                }

                return x.unidadeId === unidadeRef
              }, true)

              if (!EqualsUnidade) {
                this.$toast.error(
                  `Os equipamentos nao pertencem a mesma unidade`
                )
                return
              }
            }
            if (this.fieldSubDepartment && !this.fieldDepartment) {
              const departmentRef = this.equipment[0].departmentId

              const Equalsdepartment = this.equipment.reduce((result, x) => {
                if (!result) {
                  return false
                }

                return x.departmentId === departmentRef
              }, true)

              if (!Equalsdepartment) {
                this.$toast.error(
                  `Os equipamentos nao pertencem ao mesmo departamento`
                )
                return
              }
            }
            this.step++
          }
          break
        case 3:
          if (this.$refs.secondForm.validate()) {
            const manuf = this.manufacturers.find(
              (x) => x.name == this.manufacturer
            )

            this.equipment.forEach((x) => {
              x.unidadeId =
                this.unidadeId != null ? this.unidadeId : x.unidadeId
              x.departmentId =
                this.departmentId != null ? this.departmentId : x.departmentId
              x.subDepartmentId =
                this.subDepartmentId != null
                  ? this.subDepartmentId
                  : x.subDepartmentId
              x.manufacturer = manuf ? manuf.name : x.manufacturer
              x.manufacturerId = manuf ? manuf.id : x.manufacturerId
              x.conservationState = this.conservationState
                ? this.conservationState
                : x.conservationState
              x.endLifeFactor = this.endLifeFactor
                ? this.endLifeFactor
                : x.endLifeFactor
              x.technologyFactor = this.technologyFactor
                ? this.technologyFactor
                : x.technologyFactor
              x.marketValue = this.marketValue
                ? this.marketValue
                : x.marketValue
              x.model = this.model ? this.model : x.model
              x.reason = this.reason ? this.reason : x.reason
              x.numberAnvisa = this.anvisa ? this.anvisa : x.numberAnvisa

              x.purchasePrice = this.purchasePrice
                ? this.purchasePrice
                : x.purchasePrice
              x.purchaseDate = this.purchaseDate
                ? this.purchaseDate
                : x.purchaseDate

              x.formatPurchaseDate = this.formatInputDate(x.purchaseDate)
            })

            this.step++
          }
          break
        case 4:
          if (this.$refs.thirdForm.validate()) {
            this.confirmDialog = true
          }
          break
      }
    },

    showSuccess(message) {
      this.$emit('show', message)
    },

    selectedStandardEquipment(standardEquipmentId) {
      const standardEquipmentInstitution = this.standardEquipments.find(
        (x) => x.id === standardEquipmentId
      )
      this.equipmentName = standardEquipmentInstitution.standardEquipment.name
      this.lifeExpectancy =
        standardEquipmentInstitution.standardEquipment.lifeExpectancy
      this.indexAbc = standardEquipmentInstitution.standardEquipment.indexAbc
      this.criticality = this.calculateCriticality(
        standardEquipmentInstitution.standardEquipment
      )
    },

    calculateCriticality(standardEquipment) {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (standardEquipment.functionEquipment) {
        case 1:
          functionScore = 4
          break
        case 2:
          functionScore = 6
          break
        case 3:
          functionScore = 2
          break
        case 4:
          functionScore = 10
          break
        case 5:
          functionScore = 8
          break
        default:
          functionScore = 0
          break
      }

      switch (standardEquipment.equipmentRisk) {
        case 1:
          riskScore = 5
          break
        case 2:
          riskScore = 7
          break
        case 3:
          riskScore = 1
          break
        case 4:
          riskScore = 3
          break
        default:
          riskScore = 0
          break
      }

      switch (standardEquipment.indexAbc) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      return functionScore + riskScore + indexAbcScore
    },

    async getUndiades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.unidadeLoading = false
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/list`)
        .then((response) => {
          this.departments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getCostCenters() {
      this.costCenterLoading = true

      await this.apiService
        .get(`costCenter/listActive/${this.institutionId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.costCenterLoading = false
    },

    selectedCostCenter() {
      const costCenter = this.costCenters.find(
        (x) => x.departmentId === this.departmentId
      )
      if (costCenter) {
        this.costCenterId = costCenter.id
      }
    },

    async getSuppliers() {
      this.supplierLoading = true
      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.suppliers.unshift({
            id: 0,
            name: '',
          })
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.supplierLoading = false
    },

    async submit() {
      this.loading = true
      this.equipment = this.equipment.map((x) => {
        const manuf = this.manufacturers.find((y) => y.name == x.manufacturer)

        if (manuf && manuf.id) x.manufacturerId = manuf.id

        return x
      })

      await this.apiService
        .post('equipment/editRange', this.equipment)
        .then((response) => {
          this.showSuccess(response.message)
          this.close()
        })
        .catch(() => {
          this.loading = false
          this.confirmDialog = false
        })
    },
    formatDate(date) {
      return utils.moment(date)
    },

    formatDateTime(date) {
      return utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },

  watch: {
    fieldUnidade() {
      this.fieldDepartment = this.fieldUnidade
    },
    fieldDepartment() {
      this.fieldSubDepartment = this.fieldDepartment
    },
    editUnidade() {
      this.editDepartment = this.editUnidade
      if (!this.editUnidade) {
        this.fieldUnidade = this.editUnidade
      }
    },
    editDepartment() {
      this.editSubDepartment = this.editDepartment
      if (!this.editDepartment) {
        this.fieldDepartment = this.editDepartment
      }
    },
  },
}
